// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-rewards-maincontainer {
  margin: 0px 16px 0px 16px;
  padding: 5px 5px 0px 5px;
  border-radius: 4px;
  background-color: #f4f4f4;
  font-family: var(--font-primary);
}
.my-rewards-maincontainer .my-rewards-top-content {
  text-align: center;
  position: relative;
}
.my-rewards-maincontainer .my-rewards-top-content .reward-img {
  position: absolute;
  top: 0px;
  left: 2px;
}
.my-rewards-maincontainer .my-rewards-top-content .reward-img img {
  width: 50px;
}
.my-rewards-maincontainer .my-rewards-top-content .reward-img .img-skeleton {
  width: 40px;
  height: 30px;
  border-radius: 5px;
}
.my-rewards-maincontainer .my-rewards-top-content .rewards-titles-styes {
  display: flex;
  flex-direction: column;
}
.my-rewards-maincontainer .my-rewards-top-content .rewards-titles-styes .rewards-title {
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 15px;
  color: var(--ion-color-dark);
}
.my-rewards-maincontainer .my-rewards-top-content .rewards-titles-styes .rewards-level-label {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 8px;
  color: var(--ion-color-dark);
  transform: translateY(12px);
}
.my-rewards-maincontainer .range-container-skelton {
  display: flex;
  height: 15px;
  margin: 13px;
  border-radius: 12px;
}
.my-rewards-maincontainer .my-rewards-bottom-content {
  display: flex;
  transform: translateY(-6px);
  position: relative;
}
.my-rewards-maincontainer .my-rewards-bottom-content .rp-col {
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;
  justify-content: space-between;
}
.my-rewards-maincontainer .my-rewards-bottom-content .rp-col .rp-col-label {
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: var(--ion-color-dark);
}
.my-rewards-maincontainer .my-rewards-bottom-content .rp-col .rp-col-value {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: var(--ion-color-dark);
}
.my-rewards-maincontainer .my-rewards-bottom-content .rp-col .rp-col-value-skeleton {
  width: 50%;
  margin: 1px auto;
  height: 18px;
  border-radius: 5px;
}
.my-rewards-maincontainer .my-rewards-bottom-content ion-icon {
  position: absolute;
  bottom: -1px;
  right: 0px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-rewards/my-rewards.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gCAAA;AACJ;AACI;EACI,kBAAA;EACA,kBAAA;AACR;AACQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AACZ;AACY;EACI,WAAA;AAChB;AAEY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAAhB;AAIQ;EACI,aAAA;EACA,sBAAA;AAFZ;AAIY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAFhB;AAKY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;AAHhB;AAQI;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AANR;AASI;EACI,aAAA;EACA,2BAAA;EACA,kBAAA;AAPR;AASQ;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,kBAAA;EACA,8BAAA;AAPZ;AASY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAPhB;AAUY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AARhB;AAWY;EACI,UAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAThB;AAaQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAXZ","sourcesContent":[".my-rewards-maincontainer {\n    margin: 0px 16px 0px 16px;\n    padding: 5px 5px 0px 5px;\n    border-radius: 4px;\n    background-color: #f4f4f4;\n    font-family: var(--font-primary);\n\n    .my-rewards-top-content {\n        text-align: center;\n        position: relative;\n\n        .reward-img {\n            position: absolute;\n            top: 0px;\n            left: 2px;\n\n            img {\n                width: 50px;\n            }\n\n            .img-skeleton {\n                width: 40px;\n                height: 30px;\n                border-radius: 5px;\n            }\n        }\n\n        .rewards-titles-styes {\n            display: flex;\n            flex-direction: column;\n\n            .rewards-title {\n                font-style: normal;\n                font-weight: 900;\n                font-size: 16px;\n                line-height: 15px;\n                color: var(--ion-color-dark);\n            }\n\n            .rewards-level-label {\n                font-style: normal;\n                font-weight: 400;\n                font-size: 10px;\n                line-height: 8px;\n                color: var(--ion-color-dark);\n                transform: translateY(12px);\n            }\n        }\n    }\n\n    .range-container-skelton {\n        display: flex;\n        height: 15px;\n        margin: 13px;\n        border-radius: 12px;\n    }\n\n    .my-rewards-bottom-content {\n        display: flex;\n        transform: translateY(-6px);\n        position: relative;\n\n        .rp-col {\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n            text-align: center;\n            justify-content: space-between;\n\n            .rp-col-label {\n                font-style: normal;\n                font-weight: 400;\n                font-size: 11px;\n                line-height: 13px;\n                color: var(--ion-color-dark);\n            }\n\n            .rp-col-value {\n                font-style: normal;\n                font-weight: 700;\n                font-size: 15px;\n                line-height: 18px;\n                color: var(--ion-color-dark);\n            }\n\n            .rp-col-value-skeleton {\n                width: 50%;\n                margin: 1px auto;\n                height: 18px;\n                border-radius: 5px;\n            }\n        }\n\n        ion-icon {\n            position: absolute;\n            bottom: -1px;\n            right: 0px;\n            cursor: pointer;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
